module.exports = __webpack_public_path__ + "static/SFMono-SemiboldItalic-2fd68bed64aeaceadc6402efc4d82767.woff2";